export default "__VITE_ASSET__CzhJD2d7__"